<template>
	<div class="person_page">
		<div class="person_main">
			<div class="nav_content">
				<img class="user_photo" src="http://img09.rkang.cn/i10/p/16/53/-N7g2nW-ec8.jpg">
				<div class="nav_content_box">
					<p class="user_name">Alan Walker</p>
					<ul>
						<li :class="{nav_content_item_active:item=='study'}" @click="changeNav('study')"><p>个人学习中心</p></li>
						<li :class="{nav_content_item_active:item=='changePass'}" @click="changeNav('changePass')"><p>更改密码</p></li>
						<li :class="{nav_content_item_active:item=='binding'}" @click="changeNav('binding')"><p>已绑定账户</p></li>
						<li :class="{nav_content_item_active:item=='personInfo'}" @click="changeNav('personInfo')"><p>个人信息</p></li>
						<li :class="{nav_content_item_active:item=='transactionInfo'}" @click="changeNav('transactionInfo')"><p>交易信息</p></li>
						<li :class="{nav_content_item_active:item=='message'}" @click="changeNav('message')"><p>消息中心</p><span v-if="message_number>0">{{message_number}}</span></li>
					</ul>	
				</div>
			</div>
			<div class="person_components">
				<keep-alive>
					<component :is="item" @message="changeNav" @change_number="change_messageNumber"></component>
				</keep-alive>
			</div>
		</div>
	</div>
</template>

<script>
	import study from '../../components/personSet/study.vue'
	import changePass from '../../components/personSet/changePass.vue'
	import binding from '../../components/personSet/binding.vue'
	import personInfo from '../../components/personSet/personInfo.vue'
	import transactionInfo from '../../components/personSet/transactionInfo.vue'
	import message from '../../components/personSet/message.vue'
	import message_detail from '../../components/personSet/message_detail.vue'
	export default {
	  name: 'personSet',
	  components:{
		  study,
		  changePass,
		  binding,
		  personInfo,
		  transactionInfo,
		  message,
		  message_detail
	  },
	  data () {
	    return {
			item:'study',//默认显示个人中心，study/changePass/binding/personInfo/transactionInfo/message
			message_number:1
	    }
	  },
	  methods:{
		  changeNav:function(item){
			  this.item=item
		  },
		  change_messageNumber:function(status){
			  if(status){
				  this.message_number = this.message_number-1
			  }
		  }
	  }
	}
</script>

<style scoped="scoped">
	@import '../../../static/css/personSet.css';
	
	.person_page{
		min-width: 1024px;
		background-color: rgb(100,101,112);
		background-image: url(https://static.wixstatic.com/media/a36401_0781d530fefd4098bc0f89bdc8906fcc~mv2_d_3000_2250_s_2.jpg/v1/fill/w_1920,h_1440,al_c,q_85,usm_0.66_1.00_0.01/a36401_0781d530fefd4098bc0f89bdc8906fcc~mv2_d_3000_2250_s_2.webp);
		background-size: cover;
		background-repeat: no-repeat;
	}
	
	.nav_content{
		width: 220px;
		min-height: 200px;
		margin:0 auto;
		position: absolute;
		margin-top:200px;
	}
	.nav_content .user_photo{
		width: 100px;
		height: 100px;
		position: absolute;
		margin-top:-40px;
		border-radius: 50%;
		margin-left: 60px;
		border:2px #fff solid;
	}
	.nav_content .nav_content_box{
		width: 220px;
		min-height: 200px;
		background-color: rgba(45,47,58,0.5);
		border-radius: 20px;
	}
	.nav_content .nav_content_box .user_name{
		width: 180px;
		height:20px;
		margin:0 auto;
		padding-top:70px;
		padding-bottom:10px;
		font-size: 15px;
		color:rgba(199,199,199);
		text-align: center;
		border-bottom: 1px #414141 solid;
	}	
	.nav_content .nav_content_box ul{
		width: 100%;
		overflow: hidden;
		zoom:1;
		padding-bottom:20px;
		margin-top:10px;
	}
	.nav_content .nav_content_box ul li{
		width:100%;
		height: 40px;
		line-height: 40px;
		display: block;
		text-align: center;
	}	
	.nav_content .nav_content_box ul li p{
		font-size: 14px;
		color:rgba(199,199,199);
		cursor:pointer;
	}
	.nav_content .nav_content_box ul li span{
		padding:1px 4px;
		width: 10px;
		line-height: initial;
		background: #FF5252;
		color:#fff;
		font-size:12px;
		border-radius: 100%;
		margin-top: -35px;
		margin-left:2px;
		margin-left: 30px;
		position: absolute;
	}
	.nav_content_item_active p{
		color:rgba(255,255,255) !important;
	}
	.person_components{
		width: 750px;
		min-height:200px;
		position: relative;
		margin-top:200px;
		float: right;
		right:50px;
	}
</style>



// WEBPACK FOOTER //
// src/views/personSet/personSet.vue